import { useCallback, useEffect, useState } from 'react';
import { getTiposDeRecargosOmitidos } from 'api/configuracion/tiposDeRecargosOmitidos';

const useConfigOmisionDeRecargos = (params = null) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    const _data = await getTiposDeRecargosOmitidos(params);
    setData(_data);
    setLoading(false);
  }, [params]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, refetch: fetchData };
};

export default useConfigOmisionDeRecargos;
